import dayjs from 'dayjs'
import { ViewFeeModel } from 'src/clinic/views/clinicBrandPayoutReports/components/FeeModelViewDetails'
import { isValidNumber } from 'src/consumer/helpers/utilFunctions'
import { MOMENT_FORMATS } from 'src/consumer/constants'
import { getPriceStringWithCurrency } from 'src/mentor/helpers/utilityFunctions'

export default function FeeModelViewer({
  entityFeeModel,
  allFeeModels,
  modelNo,
  feeModelGroups,
  forMentor = false,
}) {
  let applicableToObject = feeModelGroups?.find(
    (group) => group?.id === entityFeeModel?.applicableTo,
  )
  // if (!applicableToObject) {
  //   applicableToObject = ENTITY_FEE_MODEL_APPLICABLE_TO_VALUES?.[entityFeeModel?.applicableTo]
  // }

  const title1 = applicableToObject?.titleForEntityModel || applicableToObject?.title
  let title2 = forMentor ? 'Both In Person and Online Sessions' : 'Both in Clinc & Online Sessions'

  let descriptionText = ''

  let sessionTitle = 'Sessions'
  let modeTitle = forMentor
    ? `All ${sessionTitle} both in Person & Online in Home`
    : `All ${sessionTitle} both in Clinic & Online in Home`

  if (entityFeeModel?.mode === 'online') {
    title2 = 'Online Sessions'
    modeTitle = `Online ${sessionTitle} from Home`
  }
  if (entityFeeModel?.mode === 'offline') {
    title2 = forMentor ? 'In Person Sessions' : 'In Clinic Sessions'
    modeTitle = forMentor ? `In Person ${sessionTitle}` : `In Clinic ${sessionTitle}`
  }

  const currency = entityFeeModel?.currencyCode
  const minimumFeePerSession = entityFeeModel?.minimumFeePerSession

  const minFeeTitle = `Min Fee from Patient is to be ${getPriceStringWithCurrency(
    minimumFeePerSession,
    currency,
  )} for each session`

  let minFeeTitle1 =
    'AUMHUM revenue share will be calcuated on minimum fee if fee collected is less than minimum fee'

  return (
    <div className="d-flex flex-column gap-1">
      <div className="d-flex flex-column gap-1 mb-3">
        <h4 className="mb-0">
          {modelNo}. {title1} ({title2})
        </h4>
        {!!applicableToObject?.longDesc && <span>{applicableToObject?.longDesc}</span>}
        <ValidityDisplay entityFeeModel={entityFeeModel} />
      </div>
      <span>
        <strong>Mode :</strong> {modeTitle}
      </span>
      {isValidNumber(minimumFeePerSession) && (
        <>
          <span>
            <strong>Min Fee :</strong> {minFeeTitle}
          </span>
          <span style={{ textDecoration: 'underline' }}>
            <strong>{minFeeTitle1}</strong>
          </span>
        </>
      )}
      <div className="d-flex flex-column gap-3 mt-2">
        {entityFeeModel?.feeRanges?.map((range, idx) => {
          return (
            <EntityFeeModelPriceRangeViewer
              key={idx}
              minFee={range?.min}
              maxFee={range?.max}
              currencyCode={currency}
              modelId={range?.modelId}
              allFeeModels={allFeeModels}
              forMentor={forMentor}
              currentRange={range}
            />
          )
        })}
      </div>
    </div>
  )
}

function EntityFeeModelPriceRangeViewer({
  minFee,
  maxFee,
  currencyCode,
  modelId,
  allFeeModels,
  forMentor,
  currentRange,
}) {
  const feeModel = allFeeModels?.find((model) => model?.id === modelId)

  console.log({ forMentor })

  let mainTitle = `For Fee Upto ${
    isValidNumber(maxFee) ? getPriceStringWithCurrency(maxFee, currencyCode) : 0
  }`

  if (isValidNumber(minFee) && isValidNumber(maxFee) && minFee !== 0) {
    mainTitle = `For Fee between ${
      isValidNumber(minFee) ? getPriceStringWithCurrency(minFee, currencyCode) : 0
    } - ${isValidNumber(maxFee) ? getPriceStringWithCurrency(maxFee, currencyCode) : 0}`
  }
  if (isValidNumber(minFee) && !isValidNumber(maxFee)) {
    if (minFee === 0) {
      mainTitle = `For any amount collected`
    } else {
      mainTitle = `For fee ${
        isValidNumber(minFee) ? getPriceStringWithCurrency(minFee, currencyCode) : 0
      } and above`
    }
  }

  console.log({ vald: isValidNumber(minFee), minFee, currentRange })

  return (
    <div
      className="d-flex flex-column gap-1"
      style={{ background: '#dbdbdb', borderRadius: '8px', padding: '16px' }}
    >
      <strong>{mainTitle}</strong>
      <ViewFeeModel hideHeading feeModel={feeModel} forMentor={forMentor} />
    </div>
  )
}

function ValidityDisplay({ entityFeeModel }) {
  const applicableFrom = entityFeeModel?.applicableFrom ? dayjs.utc(entityFeeModel.applicableFrom).local() : null
  const applicableTill = entityFeeModel?.applicableTill ? dayjs.utc(entityFeeModel.applicableTill).local() : null

  const formatDate = (date) => {
    return date?.format(MOMENT_FORMATS.completeDateDetailsWithMonthShortForm) || 'Not specified'
  }

  return (
    <div className="d-flex flex-column gap-1 mt-2 p-2" style={{
      backgroundColor: '#f8f9fa',
      border: '1px solid #dee2e6',
      borderRadius: '6px',
      fontSize: '14px'
    }}>
      <div className="d-flex align-items-center gap-2">
        <strong style={{ color: '#495057' }}>Valid:</strong>
        <span>
          {applicableFrom ? formatDate(applicableFrom) : 'Always'}
          {' → '}
          {applicableTill ? formatDate(applicableTill) : 'Ongoing'}
        </span>
      </div>
    </div>
  )
}
